import { useState } from 'react'
import {
  autoUpdate,
  flip,
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole
} from '@floating-ui/react'
import { Settings2 } from 'lucide-react'

import { Tooltip } from '@/components/ui/Tooltip'
import { AgentSettingsPanel } from '@/components/ChatWindow/AgentSettingsPanel'
import { useTranslations } from '@/hooks/useTranslations'

export const ToolConfigDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)
  const t = useTranslations()

  const { refs, floatingStyles, context, isPositioned } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'top-start',
    strategy: 'absolute',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(8),
      flip({
        fallbackPlacements: ['bottom-start', 'top-end', 'bottom-end']
      }),
      shift({ padding: 8 })
    ]
  })

  const click = useClick(context)
  const dismiss = useDismiss(context)
  const role = useRole(context)

  const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role])

  return (
    <div className='mp-agent-tool-config-dropdown'>
      <Tooltip content={t.agentSettingsTooltip}>
        <button
          ref={refs.setReference}
          type='button'
          className='mp-agent-composer-button mp-agent-composer-tool-button'
          aria-label={t.agentSettingsTooltip}
          {...getReferenceProps()}
        >
          <Settings2 size={16} />
        </button>
      </Tooltip>
      {isOpen && (
        <div
          ref={refs.setFloating}
          style={{
            ...floatingStyles,
            opacity: isPositioned ? 1 : 0,
            pointerEvents: isPositioned ? 'auto' : 'none',
            transition: isPositioned ? 'opacity 0.15s ease-out' : 'none'
          }}
          className='mp-agent-tool-config-panel'
          {...getFloatingProps()}
        >
          <AgentSettingsPanel />
        </div>
      )}
    </div>
  )
}

export default ToolConfigDropdown

